import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6433ce35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Actions", -1))

import { onMounted, ref } from 'vue';
import { fetchIpWhitelists, toggleStatus, deleteIP } from '@/_services/securite/whitelist/ipWhitelistService';
import { IpWhitelist } from "@/models/securite/whitelist/IpWhiteList";
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import InputSwitch from "primevue/inputswitch";
import Swal from '@/_helpers/swal';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabByIP',
  setup(__props) {

const tableData = ref<IpWhitelist[]>([]);
const currentPage = ref<number>(0);
const rows = ref<number>(10);
const totalRecords = ref<number>(0);
const loading = ref<boolean>(true);
const page = ref<number>(1);
const criteria = ref<string>("");
const toast = useToast();
const confirm = useConfirm();

async function populateDatatable() {
    loading.value = true;
    const [loadingDt, totalRecordsDt, tableDataDt] = await fetchIpWhitelists(rows.value, page.value, criteria.value.trim());
    loading.value = loadingDt.value;
    tableData.value = tableDataDt.value;
    totalRecords.value = totalRecordsDt.value;

    return [loading.value, totalRecords.value, tableData.value]
}

onMounted(async () => {
    await populateDatatable();
});

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};

const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
};

const onFilterDt = async () => {
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

const onClearInputFilter = () => {
    if (criteria.value === "") {
        rows.value = 10;
        page.value = 1;
        populateDatatable();
    }
};

const handleStatusChange = async (data: IpWhitelist) => {
    try {
        await toggleStatus(data);
        toast.add({ severity: 'success', summary: 'Success', detail: 'Le statut a bien été modifié !', life: 3000 });
        await populateDatatable();
    }  catch (error) {
        let errorMessage = 'Erreur inconnue.';
        if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
    }
};
const confirmDeleteDialog = (ip: IpWhitelist) => {
    confirm.require({
        group: 'global',
        message: 'Êtes-vous sûr de vouloir supprimer cette adresse IP ?',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: "Oui",
        rejectLabel: "Non",
        acceptClass: 'p-button-danger',
        defaultFocus: "reject",
        accept: async () => {
            try {
                await deleteIP(ip.uuid);
                toast.add({ severity: 'success', summary: 'Supprimé', detail:  `L'adresse IP a bien été supprimée`, life: 3000 });
                await populateDatatable();
            } catch (error) {
                toast.add({ severity: 'error', summary: 'Erreur de suppression', detail: `Échec de la suppression de l'adresse IP `, life: 3000 });
            }
        },
    });
};

return (_ctx: any,_cache: any) => {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Tag = _resolveComponent("Tag")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Toast),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(DataTable), {
        value: tableData.value,
        showGridlines: "",
        stripedRows: "",
        rows: rows.value,
        totalRecords: totalRecords.value,
        currentPage: currentPage.value,
        paginator: true,
        loading: loading.value,
        onPage: onPaginate,
        rowsPerPageOptions: [10, 25, 100],
        tableStyle: "min-width: 50rem",
        lazy: ""
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(InputText), {
                modelValue: criteria.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria).value = $event)),
                placeholder: "Rechercher par IP",
                onKeyup: _withKeys(onFilterDt, ["enter"]),
                onInput: onClearInputFilter
              }, null, 8, ["modelValue", "onKeyup"])
            ])
          ])
        ]),
        empty: _withCtx(() => [
          _createTextVNode("Aucun résultat trouvé.")
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(Column), {
            field: "ipAddress",
            header: "Adresse IP whitelistée"
          }),
          _createVNode(_unref(Column), {
            field: "company.name",
            header: "Société"
          }),
          _createVNode(_unref(Column), {
            field: "requestedBy",
            header: "Demandé par"
          }),
          _createVNode(_unref(Column), {
            field: "description",
            header: "Description"
          }),
          _createVNode(_unref(Column), {
            field: "createdAt",
            header: "Date d'ajout"
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(formatDate(slotProps.data.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), { header: "Ajouté par" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.createdBy.firstname) + " " + _toDisplayString(slotProps.data.createdBy.lastname), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), {
            field: "status",
            header: "Statut"
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Tag, {
                value: slotProps.data.status ? 'Actif' : 'Inactif',
                severity: slotProps.data.status ? 'success' : 'danger',
                rounded: ""
              }, null, 8, ["value", "severity"])
            ]),
            _: 1
          }),
          _createVNode(_unref(Column), null, {
            header: _withCtx(() => [
              _hoisted_5
            ]),
            body: _withCtx((slotProps) => [
              _createVNode(_unref(InputSwitch), {
                modelValue: slotProps.data.status,
                "onUpdate:modelValue": ($event: any) => ((slotProps.data.status) = $event),
                onChange: () => handleStatusChange(slotProps.data)
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"]),
              _createVNode(_unref(Button), {
                onClick: () => confirmDeleteDialog(slotProps.data),
                type: "button",
                title: "Supprimer",
                icon: "pi pi-trash",
                class: "ml-1 p-button-danger"
              }, null, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "rows", "totalRecords", "currentPage", "loading"])
    ])
  ]))
}
}

})